import db from 'database';
import Helpers from 'shared/helpers';
import moment from 'moment';

export default class EtapaProduto {
  _id;
  etapa;
  produto;
  fase;
  quantidade;
  valor;
  order;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {Number} data.etapa
   * @param {Number} data.produto
   * @param {Number} data.fase
   * @param {any} data.quantidade
   * @param {any} data.valor
   * @param {any} data.order
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.etapa_produto.filter(
      x =>
        String(x.etapa) === String(this.etapa) &&
        String(x.order) === String(this.order) &&
        String(x.fase) === String(this.fase),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    return db.etapa_produto.put(this);
  }

  static describe = () =>
    '++_id, etapa, produto, quantidade, valor, order, createdAt, updatedAt, deletedAt';
}
